<template>
  <div class="focusdevice">
    <div style="margin-bottom:.8rem">
      <el-button @click="addDevice" size="small" type="success" icon="el-icon-plus">添加设备</el-button>
    </div>
    <div v-for="(msg,index) in deviceDate" :key="index" class="device-box">
      <div class="device-imp">
        <span class="trend-title">设备名称</span>
        <el-input show-word-limit maxlength="20" type="text" placeholder="请输入" v-model="msg.devName"></el-input>
        <el-button @click="removeDevice(msg.id,index)" size="small" type="danger" icon="el-icon-minus">删除</el-button>
      </div>
      <div class="device-imp">
        <span class="trend-title">设备照片</span>
        <div style="display:inline-block; vertical-align:top;">
          <el-upload 
            class="avatar-uploader"  
            :http-request="(e)=>{uploadfile(e,index)}" 
            action="#" 
            :before-upload="beforeAvatarUpload"
            :show-file-list="false">
            <img v-if="msg.devImg" :src="msg.devImg" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
      <div class="device-imp">
        <span class="trend-title">设备介绍</span>
        <el-input show-word-limit maxlength="300" :rows="4" type="textarea" placeholder="请输入" v-model="msg.devRemark"></el-input>       
      </div>
    </div>
    <div class="last-save">
      <el-button :loading="focusLoading" size="small" @click="saveImp" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import upapi from '@/apis/upload'
import api from '@/apis/device/device'
export default {
  data(){
    return{
      focusLoading:false,//加载状态
      deviceDate:[
        {devName:'',devImg:'',devRemark:''}
      ]
    }
  },
  mounted(){
    this.getFoucs()
  },
  methods:{
    //获取数据
    getFoucs(){
      api.getStress().then(res=>{
        if(res.code==10000){
          if(res.data){
            this.deviceDate = res.data
          }
        }
      })
    },
    //保存
    saveImp(){
      this.focusLoading = true;
      api.saveStress(this.deviceDate).then(res=>{
        if(res.code==10000){
          this.focusLoading = false;
          this.getFoucs()
          this.$message.success("保存成功")
        }else{
          this.focusLoading = false;
          this.$message.error(res.message);
          return;
        }
      })
    },
    //删除重点设备
    removeDevice(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delStress([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getFoucs()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.deviceDate.splice(index,1)
      }
    },
    //图片上传成功的回调函数
    uploadfile(val,i) {
      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          this.deviceDate[i].devImg = res.data
        } else {
          this.$message.error(res.message)
          return;
        }
      })
    },
    //判断上传文件格式是否合法
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    //添加一行重点设备
    addDevice(){
      this.deviceDate.push({devName:'',devImg:'',devRemark:''})
    },
  }
}
</script>
<style lang="less" scoped>
.focusdevice{ padding-top: 10px;
  .device-box{ display:inline-block; width: 45%; padding:1rem; margin-right:1rem; margin-bottom: 1rem; border: #3570ff solid 1px;
    .device-imp{ margin-bottom: 15px; display: flex; flex-direction: row;
      .el-input,.el-select,.el-textarea{ flex: 1;}
      .avatar{ width: 8rem; height: 6rem;}
    }
  }
}
</style>